function formatIntWithCommas(int: number | string) {
  return int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default formatIntWithCommas;
